module.exports = __webpack_public_path__ + "assets/ipify.610f2f80.svg";